module.exports = {
  path: 'add',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CompanyAdd'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/companies/routes/add/index.js